/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportRefunds
 * @description Data access service for POS Sale refunds data
 */
angular.module('mercury.modules.reports.refunds').factory('ReportRefunds', ["$http", "$q", "$resource", "userinfo", "settings", function($http, $q, $resource, userinfo, settings) {
  /**
   * Get POS sale refunds for a report period, grouped specific interval
   *
   * @memberof ReportRefunds
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @param  {String} interval report interval
   * @return {Object} promise
   */
  function getByInterval(start, end, interval, companyId) {
    if (userinfo.companyPos()) {
      var deferred = $q.defer();
      var config = {params: {start: start, end: end, interval: interval}};

      // Optionally override the company-id header
      if (companyId) {
        config.headers = {
          'x-loaded-company-id': companyId,
          'x-loaded-suppress-subscription-errors': '1'
        };
      }

      $http.get(settings.mercHost + '/pos/sales/refunds', config)
      .then(function(response) {
        deferred.resolve(response.data);
      }, function(response) {
        deferred.resolve(response);
      });

      return deferred.promise;
    } else {
      return $q.when([]);
    }
  }

  return {
    getByInterval: getByInterval
  };
}]);
